import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";
import "./Blogs.css";

import { API_BASE_URL } from "../../config";

const BlogsList = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/api/blogs`);
            if (!response.ok) {
                throw new Error("Failed to fetch articles.");
            }
            const data = await response.json();
            setBlogs(data);
        } catch (err) {
            setError(err.message || "Unable to load blogs at this time.");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <>
            <Navbar />

            <div className="blogs-list-container">
                <h2 className="am-h2" style={{ paddingTop: "80px", marginBottom: "20px" }}>
                    Our <span>Blogs</span>
                </h2>
                <p style={{ textAlign: "center", color: "#555", fontSize: "18px", maxWidth: "700px", margin: "0 auto 50px auto", fontWeight: "500", lineHeight: "1.6" }}>
                    Explore articles, guides, and thoughts on Montessori education, early childhood learning, and home activities.
                </p>

                {loading ? (
                    <div style={{ textAlign: "center", padding: "60px", fontSize: "18px", color: "#777" }}>
                        Loading latest stories...
                    </div>
                ) : error ? (
                    <div style={{ textAlign: "center", padding: "60px", color: "#ef4444", fontSize: "16px" }}>
                        {error}
                    </div>
                ) : blogs.length === 0 ? (
                    <div className="no-blogs-public">
                        <h3>No articles published yet</h3>
                        <p>Check back soon for insights and updates!</p>
                    </div>
                ) : (
                    <div className="blogs-grid">
                        {blogs.map((blog) => (
                            <div
                                key={blog._id}
                                className="blog-card"
                                onClick={() => navigate(`/blogs/${blog.slug}`)}
                            >
                                <div className="blog-card-banner">
                                    {blog.coverImage ? (
                                        <img src={blog.coverImage} alt={blog.title} />
                                    ) : (
                                        <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg, #facf23aa 0%, #ff8943aa 100%)" }} />
                                    )}
                                </div>
                                <div className="blog-card-content">
                                    <div className="blog-card-date">{formatDate(blog.createdAt)}</div>
                                    <h3 className="blog-card-title">{blog.title}</h3>
                                    <p className="blog-card-excerpt">
                                        {blog.excerpt || "Click read more to view details of this educational article."}
                                    </p>
                                    <div className="blog-card-readmore">
                                        Read Article <i className="fa-solid fa-arrow-right-long"></i>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <Footer />
        </>
    );
};

export default BlogsList;
